import React from 'react';

import type { ClassificationLine } from './scoring-types';

interface Props {
  total: number;
  lines: ClassificationLine[];
}

function signedPoints(points: number): string {
  return points > 0 ? `+${points}` : points < 0 ? `−${Math.abs(points)}` : '0';
}

// System klasyfikacji bywa zawiły, więc modal rozpisuje liczbę z kolumny „Klas."
// na składowe — każda z tym, skąd się wzięła.
export const ClassificationBreakdown: React.FC<Props> = ({ total, lines }) => {
  if (lines.length === 0) {
    return null;
  }

  return (
    <details className="classification-breakdown" data-testid="classification-breakdown">
      <summary className="classification-breakdown__summary">
        Klasyfikacja: <strong>{total} pkt</strong> — skąd?
      </summary>
      <ul className="classification-breakdown__list">
        {lines.map((line) => (
          <li key={line.label} className="classification-breakdown__line">
            <span className="classification-breakdown__label">
              {line.label}
              <span className="classification-breakdown__detail">{line.detail}</span>
            </span>
            <span className="classification-breakdown__points">{signedPoints(line.points)}</span>
          </li>
        ))}
        <li className="classification-breakdown__line classification-breakdown__line--total">
          <span className="classification-breakdown__label">Razem</span>
          <span className="classification-breakdown__points">{total}</span>
        </li>
      </ul>
    </details>
  );
};

export default ClassificationBreakdown;
